import { createSelector } from '@reduxjs/toolkit';
import { selectJsonQuery } from './selectJsonQuery';
import { getTermsValue } from '../../../packages/JsonQuery';

export const selectRoomTypeFilter = createSelector(
  selectJsonQuery,
  jsonQuery => getTermsValue('room')(jsonQuery)?.[0] || 'all',
);
